// import PropTypes from 'prop-types';
import DistibutorCard from '../DistibutorCard/DistibutorCard';
import styles from './DistributorCardList.module.scss';

const DistributorCardList = ({ items }) => {
    return (
        <div className={styles['DistributorCardList']}>
            <div className={styles['DistributorCardList__Container']}>
                <div className={styles['DistributorCardList__List']}>
                    {items?.map((item, i) => (
                        <div
                            key={i}
                            className={styles['DistributorCardList__Item']}
                        >
                            <DistibutorCard {...item} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

DistributorCardList.propTypes = {};

DistributorCardList.defaultProps = {};

export default DistributorCardList;
